var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.table.content.length)?[_c('DataTable',{attrs:{"header":_vm.table.headers,"table":_vm.table.content},on:{"edit":_vm.editStoreContent,"checkConfirm":_vm.editStoreContent}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }